export default __webpack_public_path__ + "static/media/TeruGifNew.d0195698.gif";